/* ============================================================
 * N36 quick add — PLP/search/carousel card dialog (7/12)
 * One delegated controller for every n36-qa <dialog> on the page.
 * The <script src> tag renders once per multi-variant card, so the
 * whole file is guarded — first execution wins, the rest no-op.
 * Add is AJAX (/cart/add, JSON) so the customer never leaves the
 * grid; on failure we fall through to the product page. On the
 * live theme iCart observes the cart change and opens its drawer.
 * 2026-08-05 (iCart outage): adaptive after-add — when iCart's
 * drawer isn't on the page, go to /cart like every other add;
 * when iCart returns, the stay-on-grid behavior returns with it.
 * ============================================================ */
(function () {
  if (window.__n36QA) return;
  window.__n36QA = 1;

  function bubbleBump(qty) {
    // best-effort header cart-count refresh (Dawn bubble); cosmetic only
    var b = document.querySelector('.cart-count-bubble span[aria-hidden]');
    if (b) {
      var n = parseInt((b.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) b.textContent = String(n + qty);
    }
  }

  // iCart present on this pageview? (drawer toggle in DOM). When absent the
  // add has no visible destination, so we send the customer to /cart.
  function icartHere() {
    return !!document.querySelector('.iCartBtnToggle');
  }

  // Button price must ALWAYS mirror the checked size. Split out so it runs
  // on open too — relying on `change` alone left the button stale whenever
  // the checked radio and the server-rendered price disagreed (2026-08-04,
  // Asher's screenshot: 10-12oz selected, button still "— $23").
  function syncPrice(d) {
    if (!d) return;
    var sel = d.querySelector('[data-n36-qa-sel]:checked') || d.querySelector('[data-n36-qa-sel]');
    if (!sel) return;
    var raw = sel.tagName === 'SELECT'
      ? (sel.selectedOptions[0] && sel.selectedOptions[0].getAttribute('data-price'))
      : sel.getAttribute('data-price');
    var price = d.querySelector('[data-n36-qa-price]');
    if (raw && price) price.textContent = '— ' + raw;
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-n36-qa-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('aria-controls'));
      if (d && typeof d.showModal === 'function') {
        d.__n36Opener = open;
        d.showModal();
        syncPrice(d);
        var s = d.querySelector('[data-n36-qa-sel]:checked') || d.querySelector('[data-n36-qa-sel]');
        if (s) s.focus();
      } else {
        // ancient browser without <dialog>: go pick on the product page
        window.location.href = open.getAttribute('data-url');
      }
      return;
    }
    var x = e.target.closest('[data-n36-qa-close]');
    if (x) {
      var dx = x.closest('dialog');
      if (dx) dx.close();
      return;
    }
    var step = e.target.closest('[data-n36-qa-step]');
    if (step) {
      var ds = step.closest('dialog');
      var hidden = ds.querySelector('input[name="quantity"]');
      var view = ds.querySelector('[data-n36-qa-qty]');
      var v = (parseInt(hidden.value, 10) || 1) + (step.getAttribute('data-n36-qa-step') === '+' ? 1 : -1);
      v = Math.min(50, Math.max(1, v));
      hidden.value = String(v);
      view.textContent = String(v);
      return;
    }
    // backdrop click: content fills the dialog, so a click whose target IS
    // the dialog element itself can only be the backdrop
    if (e.target instanceof HTMLElement && e.target.matches('dialog.n36-qa')) e.target.close();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-n36-qa-sel]');
    if (!sel) return;
    syncPrice(sel.closest('dialog'));
  });

  // return focus to the opening button so keyboard users keep their place
  document.addEventListener('close', function (e) {
    if (e.target instanceof HTMLElement && e.target.matches('dialog.n36-qa') && e.target.__n36Opener) {
      e.target.__n36Opener.focus();
    }
  }, true);

  // single-variant card forms: AJAX add. With iCart on the page the drawer
  // opens and the customer stays on the grid (Asher 7/26); without it we
  // navigate to /cart so the add always lands somewhere visible (8/5).
  document.addEventListener('submit', function (e) {
    var cf = e.target.closest('.n36-card-form');
    if (cf) {
      e.preventDefault();
      var cbtn = cf.querySelector('.n36-card-btn');
      if (cbtn && cbtn.disabled) return;
      if (cbtn) cbtn.disabled = true;
      fetch('/cart/add', { method: 'POST', body: new FormData(cf), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (cbtn) cbtn.textContent = 'Added to your cart';
          bubbleBump(1);
          document.dispatchEvent(new CustomEvent('n36:cart:added'));
          if (!icartHere() && window.N36_NATIVE_CART !== true) { window.location.href = '/cart'; return; }
          setTimeout(function () {
            if (cbtn) { cbtn.disabled = false; cbtn.textContent = 'Add to Cart'; }
          }, 1400);
        })
        .catch(function () { cf.submit(); }); // real failure: let the native POST finish the job
      return;
    }
    var form = e.target.closest('[data-n36-qa-form]');
    if (!form) return;
    e.preventDefault();
    var d = form.closest('dialog');
    var btn = form.querySelector('.n36-qa-add');
    var label = form.querySelector('[data-n36-qa-label]');
    if (btn.disabled) return; // double-submit guard
    btn.disabled = true;
    var qty = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;
    fetch('/cart/add', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        bubbleBump(qty);
        document.dispatchEvent(new CustomEvent('n36:cart:added'));
        if (!icartHere() && window.N36_NATIVE_CART !== true) { window.location.href = '/cart'; return; }
        // Close NOW (Asher 2026-08-11: 'once you add it should disappear and
        // leave you in cart') - the iCart drawer is the confirmation surface.
        if (d) d.close();
        btn.disabled = false;
        if (label) label.textContent = 'Add to Cart';
      })
      .catch(function () {
        // network/stock hiccup: the product page can always finish the job
        window.location.href = form.getAttribute('data-url') || '/cart';
      });
  });
  // Belt: if iCart processes an add (its fetch wrapper can starve our success
  // handler), its own events still force any open quick-add dialog shut.
  ['icartAddToCartEvent', 'icartUpdateCartEvent'].forEach(function (ev) {
    try { window.addEventListener(ev, function () {
      document.querySelectorAll('dialog.n36-qa[open]').forEach(function (x) { x.close(); });
    }); } catch (e) {}
  });
})();
